import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PostItem } from '@app/core/models';
import { SHARED_MODULES } from '@app/shared';

@Component({
  selector: 'app-subtitle-announcement',
  imports: [SHARED_MODULES],
  templateUrl: './subtitle-announcement.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubtitleAnnouncementComponent {
  @Input({ required: true }) public item: PostItem;

  public get data(): string[] {
    return [
      !!this.item.metadata.code ? `Nº ${this.item.metadata.code}` : this.item.metadata.code,
      this.item.metadata.author,
    ].filter((data) => !!data);
  }
}
